<template>
  <v-container fluid style="padding:0px">

    <v-row v-if="isLoading">
            <v-col cols="12" >
                <v-skeleton-loader
                type="table-tbody"
                ></v-skeleton-loader>
            </v-col>
        </v-row>

    <v-row v-if="!errorMessage" v-show="!isLoading" style="padding:0px">
      <v-col cols="12" ref="superset" v-if="this.accessAllowed">

      </v-col>

        <v-col cols="12" v-if="!this.accessAllowed">
      <div class="transparent empty-state center-align">
          <div class="mx-auto align-center d-flex flex-column" style="width: 100%;">
              <div class="text-center">
                  <i class="large material-icons" style="cursor: pointer;">table_chart</i>
                  <h4>{{ $t('wkt.admin.em.main.empty-title') }}</h4>
                  <p>{{ $t('wkt.admin.em.main.empty-subtitle') }}</p>
              </div>
          </div>
      </div>
  </v-col>
    </v-row>



    <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
    <v-snackbar
      v-model="showAlert"
      :timeout="alertTimeout"
      :color="alertColor">
        <span style="color: #ffffff;">{{alertText}}</span>
        <v-btn text @click="showAlert=false">
          <span style="color: #ffffff;">Cerrar</span>
        </v-btn>
    </v-snackbar>
    <!-- FIN BLOQUE ESTADO PETICIONES -->

  </v-container>
</template>

<script>
import api from '../../api/worktime'
import gwt from '../../api/gwt';
import discovery from '../../discovery';
import { embedDashboard } from "@superset-ui/embedded-sdk";

export default {
  name: 'SupersetModule',
  components: {
  },

  data () {
      return { 
        isLoading: false,
				apiLoading: false,
				errorMessage: null,
				showAlert: false,
				alertColor: 'error',
				alertText: '',
				alertTimeout: 3000,
				totalItems: 0,
				companies: [],
				items: [],
        dashboard:null,
        accessAllowed: true
        }
    },
  methods: {
		doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
    loadDashboard(vm){

              // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
              const dashboardUiConfig = vm.dashboard && vm.dashboard.clientConfig ? JSON.parse(vm.dashboard.clientConfig) : {hideTitle: true};
              const container = vm.$refs.superset;
              embedDashboard({
                id: this.dashboard.report, // given by the Superset embedding UI
                supersetDomain: discovery.superset_base_url,
                mountPoint: container, // any html element that can contain an iframe
                fetchGuestToken: this.fetchGuestToken,
                dashboardUiConfig: dashboardUiConfig,
              }).then( ()=> {
                    container.children[0].style.width='100%';
                    container.children[0].style.height='calc(100vh - 80px)';
                    container.children[0].border=0;
                    container.children[0].style.border=0;
                    vm.isLoading = false;
              });

            

    }, 
    fetchGuestToken() {
      return new Promise((resolve, reject) => {
          api.getSupersetGuestToken(this.dashboard.id, token=>{
              resolve(token);
          }, error=> {
              reject(error);
          });
          
        });
    },
    onReveal(payload) {
        let profile = gwt.getSessionProfile();

        if (!profile || !payload) { //todavía no se ha inicializado la aplicación
            this.accessAllowed=false;
            return;
        }

        this.accessAllowed=true;
        this.dashboard = payload;
        this.isLoading=true;

        const me = this;
        setTimeout( ()=> me.loadDashboard(me), 100);
        
    }
  },
}
</script>

